import React, { useState } from 'react';
import { connect } from 'react-redux';
import { importExternalGroupRelationAction, importExternalGroupRelationFailure } from '../actions';
import ErrorContainer from '../components/ErrorContainer';

const BulkImport = ({ 
  importExternalGroupRelationAction, 
  importExternalGroupRelationFailure, 
  errors, 
  isImporting, 
  notice,
  fileUploadLimit15mb 
}) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file) {
      importExternalGroupRelationFailure(['No file selected']);
      return;
    }
    importExternalGroupRelationAction(file);
  };

  return (
    <div className="bulk_import">
      <h2>Import</h2>
      <ErrorContainer errors={errors} />
      {notice && <div className="notice">{notice}</div>}
      <form onSubmit={handleSubmit} className="bulk_import_fields">
        <p>CSV Upload</p>
        <label className="button" htmlFor="egr">Choose file</label>
        {fileUploadLimit15mb ? (
          <input
            id="egr egr_file"
            name="egr"
            type="file"
            accept=".csv"
            required
            onChange={handleFileChange}
            max="15MB"
          />
        ) : (
          <input
            id="egr"
            name="egr"
            type="file"
            accept=".csv"
            required
            onChange={handleFileChange}
          />
        )}
        <button
          type="submit"
          className="button egr-bulk-submit"
          disabled={isImporting}
        >
          {isImporting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  errors: state.egrImport.errors,
  isImporting: state.egrImport.isImporting,
  notice: state.egrImport.notice,
  fileUploadLimit15mb: state.egrImport.fileUploadLimit15mb,
});

const mapDispatchToProps = {
  importExternalGroupRelationAction,
  importExternalGroupRelationFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkImport);